import styled from "styled-components";

const Select = styled.select`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  border-radius: 4px;
  font-size: 12px;
  line-height: 14px;
  text-indent: 15px;
  color: #2d3a41;

  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='9' height='5' viewBox='0 0 9 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L4.5 4L8 1' stroke='%23AAB2BB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat, repeat;
  background-position: right 10px top 50%, 0 0;
  background-size: 8px auto, 100%;
`;

export default Select;
